import { Component, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { DataSharingService } from "../../AuthGuard/DataSharingService";
import { RequestModel } from "../../Shared/Models/app.MasterRequestModel";
import { MasterService } from "../../Shared/app.Masters.Service";
import { SnackbarComponent } from "../../snackbar/snackbar.component";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { DialogService } from "../../Shared/dialog.service";

declare var $: any;

@Component({
  selector: 'app-voucher-auth-emp-master',
  templateUrl: './voucher-auth-emp-master.component.html',
  styleUrls: ['./voucher-auth-emp-master.component.scss'],
  standalone: false
})
export class VoucherAuthEmpMasterComponent implements OnInit {
  private data: any;
  private _MasterService;
  showSpinner: boolean = false;
  RequestModel: RequestModel = new RequestModel();
  GetBranchesRequestModel: RequestModel = new RequestModel();
  dataSource: any;
  FromAmount: any = 0;
  ToAmount: any;
  finalList: any = [];
  displayedColumns: string[] = ["VoucherType", "Employee"];
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  FilterBranchId: any = "";
  FilterBranchList: any = [];
  productList: any[] = [];
  currentUser: any;
  ProductId: any = "";
  EmployeeList = [];
  ID: any = 0;
    VoucherTypeList: any[] = [];
  // cardsData: any[];
  lastToLoanAmount: any;
  showResults: boolean = false;
  isEditMode: boolean = false;
    EmployeeId: any = "0";

    employeeSlabList: any[] = [];
EmpId: any = "";
VoucherType_Id: any = "";
Voucher_SubType_id: any[] = [];
  ReportingManagerDropdown: any;
    ReportingManagerRequestModel: RequestModel = new RequestModel();
  RolesDropdownData: any = [];
    SelectRoleId: any = '';
  EmpManagerId: any;
  EmployeeName: any;
  EmployeeDetailData: any = {};

    VoucherSubTypeList: any = [];
  voucherSubTypeDropdownSettings: any = {};

  voucherTypeSubTypeTotals: { [key: string]: number } = {};
availableVoucherTypeList: any[] = [];





  constructor( public snackBar: MatSnackBar,
    private dataSharingService: DataSharingService,
    private MasterService: MasterService,
    private dialog: DialogService,) 
    {
        this._MasterService = MasterService;
      this.data = JSON.parse(sessionStorage.getItem("currentUser")); 
    }
  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };
  ngOnInit(): void {
    // this.FromAmount = this.lastToLoanAmount;
    this.dataSharingService.HeaderTitle.next("Voucher Authorization Config");
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    this.EmployeeId = sessionStorage.getItem('getEmployeeID');
    if (this.EmployeeId != "0") {
      // this.isEdit = true;
      // this.IsCreateEmployee = false;
      this.Get_Master();
      this.getEmployeeData();
    }

    this.getBranchEmployeeProcessList();
    this.GetBranchesRequestModel.DistrictId = 0;
    this.GetBranchesRequestModel.TehsilId = 0;
    // this._MasterService
    //   .GetBranchesDropdown(this.GetBranchesRequestModel)
    //   .subscribe((result) => {
    //     this.FilterBranchList = JSON.parse(JSON.stringify(result));
    //   });
    this.getProductList();
    this.getVoucherTypeList();
    this.RequestModel.BranchId = 0;
    this.RequestModel.RoleId = 0;
    this.MasterService.GetEmployeeList(this.RequestModel).subscribe(
      (res: any) => {
        this.EmployeeList = res;
      }
    );
  }

  // getVoucherSubTypeList() {
  //   this._MasterService.Get_Voucher_Sub_Type_List({
  //     VoucherTypeId: this.VoucherType_Id
  //   }).subscribe((res: any) => {
  //     console.log(res);
  //     this.VoucherSubTypeList = res;
  //   });

  //   this.initializeDropdownSettings();
  // }
  getVoucherSubTypeList() {
  this._MasterService.Get_Voucher_Sub_Type_List({
    VoucherTypeId: this.VoucherType_Id
  }).subscribe((res: any) => {
    console.log(res);
    const usedIds = this.getUsedSubTypeIds(this.VoucherType_Id);
    this.VoucherSubTypeList = (res || []).filter((s: any) => !usedIds.includes(+s.Id));
  });

  this.initializeDropdownSettings();
}


initializeDropdownSettings() {
    this.voucherSubTypeDropdownSettings = {
      singleSelection: false,
      idField: "Id",
      textField: "Value",
      selectAllText: "Select All",
      unSelectAllText: "Deselect All",
      allowSearchFilter: true,
      itemsShowLimit: 1,
      showSelectedItemsAtTop: true,
    };
  }
  onVoucherSubTypeSelectionChange() {
    this.VoucherSubTypeList = this.moveSelectedItemsToTop(
      this.VoucherSubTypeList,
      this.Voucher_SubType_id,
      "Voucher_SubType_id"
    );
  }
  moveSelectedItemsToTop(items: any[], selectedItems: any[], key: string): any[] {
    if (!items?.length) return [];
    if (!selectedItems?.length) return items;

    const selectedIds = selectedItems.map((s) => s[key]);
    const selected = items.filter((i) => selectedIds.includes(i[key]));
    const rest = items.filter((i) => !selectedIds.includes(i[key]));
    return [...selected, ...rest];
  }
    getSelectedIds(items: any[], key: string): string {
      return items?.map((item) => item[key]).join(",") || "0";
    }

  Get_Master() {
    this.showSpinner = true;
    this._MasterService.GetRoleForDropdown().subscribe((result) => {
      this.RolesDropdownData = JSON.parse(JSON.stringify(result));
    });
    this._MasterService.ReportingManagerForDropdown(this.ReportingManagerRequestModel).subscribe((result) => {
      this.ReportingManagerDropdown = JSON.parse(JSON.stringify(result));
      this.showSpinner = false;
    });
  }
  getEmployeeData() {
      // this.LoanProcessList = [];
      this.RequestModel.EmpId = (this.EmployeeId);
      this._MasterService.GetEmployeeDetails(this.RequestModel).subscribe((result) => {
        //console.log("RESULT :",result);
        
        this.EmployeeDetailData = result;
        console.log("EmployeeDetailData :", this.EmployeeDetailData);
     
        this.EmployeeName = this.EmployeeDetailData.Item1[0].Emp_FirstName + ' ' + this.EmployeeDetailData.Item1[0].Emp_LastName;
        // this.LastName = this.EmployeeDetailData.Item1[0].Emp_LastName;
        this.SelectRoleId = this.EmployeeDetailData.Item1[0].Emp_RoleId;
        this.EmpManagerId = this.EmployeeDetailData.Item1[0].Emp_ManagerId;
  
        // this.LoanProcessList = this.EmployeeDetailData.Item5;
        // this.LoanProcessList.map((item) => {
        //   item.isActiveSelect = item.ProcessAlradyAssigned;
        //   item.isDisable = item.ProcessAlradyAssigned;
        // });
  
  
  
      });
    }
  getProductList() {
      this._MasterService.GetProductList({}).subscribe((result) => {
        this.productList = result;
      });
    }
  //    getVoucherTypeList() {
  //   this._MasterService
  //     .GetCommonMaster_FOR_DROPDOWN({ Type: "Voucher Type" })
  //     .subscribe((res: any) => {
  //       console.log(res);
  //       this.VoucherTypeList = res;
  //     });
  // }
  getVoucherTypeList() {
  this._MasterService
    .GetCommonMaster_FOR_DROPDOWN({ Type: "Voucher Type" })
    .subscribe((res: any) => {
      console.log(res);
      this.VoucherTypeList = res || [];
      this.loadVoucherSubTypeTotals();
    });
}
loadVoucherSubTypeTotals() {
  this.voucherTypeSubTypeTotals = {};
  if (!this.VoucherTypeList?.length) {
    this.availableVoucherTypeList = [];
    return;
  }
  let pending = this.VoucherTypeList.length;
  this.VoucherTypeList.forEach((vt: any) => {
    this._MasterService
      .Get_Voucher_Sub_Type_List({ VoucherTypeId: vt.Id })
      .subscribe((res: any) => {
        this.voucherTypeSubTypeTotals[vt.Id] = (res || []).length;
        pending--;
        if (pending <= 0) {
          this.refreshAvailableVoucherTypes();
        }
      });
  });
}
refreshAvailableVoucherTypes() {
  this.availableVoucherTypeList = (this.VoucherTypeList || []).filter((vt: any) => {
    const total = this.voucherTypeSubTypeTotals[vt.Id];
    if (total === undefined || total === 0) return true;
    const used = this.getUsedSubTypeIds(vt.Id).length;
    return used < total;
  });
}
getUsedSubTypeIds(voucherTypeId: any): number[] {
  const used: number[] = [];
  (this.employeeSlabList || []).forEach((item: any) => {
    if (this.isEditMode && this.ID && item.Id === this.ID) return;
    if (String(item.VoucherType_Id) === String(voucherTypeId)) {
      (item.Voucher_SubType_id || "")
        .toString()
        .split(",")
        .map((id: string) => id.trim())
        .filter((id: string) => id.length > 0)
        .forEach((id: string) => used.push(+id));
    }
  });
  return used;
}


//   getBranchEmployeeProcessList() {
//   this.showResults = true;
//   this._MasterService
//     .Get_Voucher_Authorization_Employee_Dropdown_Master()
//     .subscribe((result) => {
//       console.log("result", result);
//       if (result && result.length > 0) {
//         this.employeeSlabList = result;
//         this.lastToLoanAmount = result[result.length - 1].To_LoanAmount;
//         this.FromAmount = this.lastToLoanAmount + 1;
//       } else {
//         this.employeeSlabList = [];
//         this.FromAmount = 0;
//       }
//     });
// }
getBranchEmployeeProcessList() {
  this.showResults = true;
  this._MasterService
    .Get_Voucher_Authorization_Employee_Dropdown_Master({
      EmpId: this.EmployeeId ? this.EmployeeId : "",
    })
    .subscribe((result) => {
      console.log("result", result);
      if (result && result.length > 0) {
        this.employeeSlabList = result;
        // this.lastToLoanAmount = result[result.length - 1].To_LoanAmount;
        // this.FromAmount = this.lastToLoanAmount + 1;
      } else {
        this.employeeSlabList = [];
        this.FromAmount = 0;
      }
      this.refreshAvailableVoucherTypes();
    });
}

AddBranchEmployeeProcess() {
  this.isEditMode = false;
  this.ID = 0;
  this.getBranchEmployeeProcessList();
  this.ToAmount = "";
  this.EmpId = this.EmployeeId ? this.EmployeeId : "";
  this.VoucherType_Id = "";
  this.Voucher_SubType_id = [];

  $("#BranchEmployeeProcessModel").modal("show");
  $("#BranchEmployeeProcessModel").css("z-index", "1050");
  this.showSpinner = false;
}

validateAmounts(): boolean {
  return this.ToAmount > this.FromAmount;
}

OnSaveBranchEmployeeProcessModel() {
  if (!this.EmpId) {
    this.snackBar.openFromComponent(SnackbarComponent, {
      data: "Please select an Employee",
      ...this.configSuccess,
    });
    return;
  }
  if (!this.VoucherType_Id) {
    this.snackBar.openFromComponent(SnackbarComponent, {
      data: "Please select a Voucher Type",
      ...this.configSuccess,
    });
    return;
  }

  this._MasterService
    .Save_Voucher_Authorization_Employee_Dropdown_Master({
      EmpId: this.EmpId,
      VoucherType_Id: this.VoucherType_Id,
      Voucher_SubType_id: this.getSelectedIds(this.Voucher_SubType_id, "Id"),
      loginUserId: this.currentUser.userId,
      Id: this.ID,
      From_LoanAmount: this.FromAmount,
      To_LoanAmount: this.ToAmount,
    })
    .subscribe((result) => {
      if (result[0].CODE == 0) {
        this.getBranchEmployeeProcessList();
        this.OnCloseBranchEmployeeProcess();

        this.snackBar.openFromComponent(SnackbarComponent, {
                    data: result[0].MSG,
                    ...this.configSuccess,
                  });
      }
    });
}

OnCloseBranchEmployeeProcess() {
  $("#BranchEmployeeProcessModel").modal("hide");
  this.ID = 0;
}

// EditBranchEmployeeProcess(id, item) {
//   this.isEditMode = true;
//   this.ID = id;
//   this.FromAmount = item.From_LoanAmount;
//   this.ToAmount = item.To_LoanAmount;
//   this.EmpId = item.EmpId;
//   this.VoucherType_Id = item.VoucherType_Id;
//   this.Voucher_SubType_id = item.Voucher_SubType_id;

//   $("#BranchEmployeeProcessModel").modal("show");
//   $("#BranchEmployeeProcessModel").css("z-index", "1050");
//   this.showSpinner = false;
// }
//   EditBranchEmployeeProcess(id, item) {
//   this.isEditMode = true;
//   this.ID = id;
//   this.FromAmount = item.From_LoanAmount;
//   this.ToAmount = item.To_LoanAmount;
//   this.EmpId = this.EmployeeId ? this.EmployeeId : item.EmpId;
//   this.VoucherType_Id = item.VoucherType_Id;

//   this.initializeDropdownSettings();

//   // Load the subtype list for this voucher type, then map the saved
//   // comma-separated ids onto the matching objects for the multiselect
//   this._MasterService
//     .Get_Voucher_Sub_Type_List({ VoucherTypeId: this.VoucherType_Id })
//     .subscribe((res: any) => {
//       this.VoucherSubTypeList = res;

//       const selectedIds = (item.Voucher_SubType_id || "")
//         .toString()
//         .split(",")
//         .map((id: string) => id.trim())
//         .filter((id: string) => id.length > 0)
//         .map((id: string) => +id);

//       this.Voucher_SubType_id = this.VoucherSubTypeList.filter((subType: any) =>
//         selectedIds.includes(subType.Id)
//       );
//     });

//   $("#BranchEmployeeProcessModel").modal("show");
//   $("#BranchEmployeeProcessModel").css("z-index", "1050");
//   this.showSpinner = false;
// }


EditBranchEmployeeProcess(id, item) {
  this.isEditMode = true;
  this.ID = id;
  this.FromAmount = item.From_LoanAmount;
  this.ToAmount = item.To_LoanAmount;
  this.EmpId = this.EmployeeId ? this.EmployeeId : "";
  this.VoucherType_Id = item.VoucherType_Id;

    this.refreshAvailableVoucherTypes(); 
  this.ensureSelectedVoucherTypeVisible();

  this.initializeDropdownSettings();



  this._MasterService
    .Get_Voucher_Sub_Type_List({ VoucherTypeId: this.VoucherType_Id })
    .subscribe((res: any) => {
      // this.ID is already set above, so getUsedSubTypeIds skips this
      // slab's own reservations and only excludes OTHER slabs' picks
      const usedIds = this.getUsedSubTypeIds(this.VoucherType_Id);
      this.VoucherSubTypeList = (res || []).filter((s: any) => !usedIds.includes(+s.Id));

      const selectedIds = (item.Voucher_SubType_id || "")
        .toString()
        .split(",")
        .map((id: string) => id.trim())
        .filter((id: string) => id.length > 0)
        .map((id: string) => +id);

      this.Voucher_SubType_id = this.VoucherSubTypeList.filter((subType: any) =>
        selectedIds.includes(subType.Id)
      );
    });

  $("#BranchEmployeeProcessModel").modal("show");
  $("#BranchEmployeeProcessModel").css("z-index", "1050");
  this.showSpinner = false;
}
ensureSelectedVoucherTypeVisible() {
  if (!this.VoucherType_Id) return;
  const alreadyPresent = this.availableVoucherTypeList.some(
    (v: any) => String(v.Id) === String(this.VoucherType_Id)
  );
  if (!alreadyPresent) {
    const full = (this.VoucherTypeList || []).find(
      (v: any) => String(v.Id) === String(this.VoucherType_Id)
    );
    if (full) {
      this.availableVoucherTypeList = [...this.availableVoucherTypeList, full];
    }
  }
}
    DeleteBranchEmployeeProcess(id){
        this.dialog
        .openConfirmDialog(`Are you sure you want to delete this?`)
        .afterClosed()
        .subscribe((dialogResult) => {
          if (dialogResult == false) {
            return;
          } else {
        this._MasterService
          .Delete_Voucher_Authorization_Employee_Dropdown_Master({
            LoginUserId: this.currentUser.userId,
            Id: id,
            EmpId: this.EmployeeId ? this.EmployeeId : "",
          })
          .subscribe((result: any) => {
            if(result[0].CODE==0){
              this.getBranchEmployeeProcessList();
            this.OnCloseBranchEmployeeProcess();

            this.snackBar.openFromComponent(SnackbarComponent, {
                    data: result[0].MSG,
                    ...this.configSuccess,
                  });
            }
            else {
                  this.snackBar.openFromComponent(SnackbarComponent, {
                    data: result[0].MSG,
                    ...this.configSuccess,
                  });
                }
          });
  
        }
      })
    }

}
